import { render, staticRenderFns } from "./barChart.vue?vue&type=template&id=dcad746a&lang=pug&"
import script from "./barChart.vue?vue&type=script&setup=true&lang=js&"
export * from "./barChart.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./barChart.vue?vue&type=style&index=0&id=dcad746a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports